import request from '@/utils/request'

// 查询当天需考勤数据
export function getTodaySchedules() {
  return request({
    url: '/educational/schedulePlan/getTodaySchedules',
    method: 'get'
  })
}

// 查询考勤数据
export function getSchedulePlanListForPage(param) {
  return request({
    url: '/educational/schedulePlan/getSchedulePlanListForPage',
    method: 'get',
    params: param
  })
}

// 查询考勤数据
export function getSchedulePlanListByStudent(param) {
  return request({
    url: '/educational/schedulePlan/getSchedulePlanListByStudent',
    method: 'get',
    params: param
  })
}

// 查询教师考勤数据
export function getTeacherSchedulePlanListForPage(param) {
  return request({
    url: '/educational/schedulePlan/getTeacherSchedulePlanListForPage',
    method: 'get',
    params: param
  })
}

// 查询排课计划列表
export function getSchedulePlanList(param) {
  return request({
    url: '/educational/schedulePlan/getSchedulePlanList',
    method: 'get',
    params: param
  })
}



// 查询有排课的日期集合
export function getAttendanceDates(param) {
  return request({
    url: '/educational/schedulePlan/getAttendanceDates',
    method: 'get',
    params: param
  })
}

// 查询课程计划考勤详情
export function getAttendanceDetailByPlanIdForH5(schedulePlanId) {
  return request({
    url: 'educational/studentSchedule/getAttendanceDetailByPlanIdForH5/' + schedulePlanId,
    method: 'get'
  })
}

// H5家长端-课程点评详情
export function getH5EvaluationDetail(studentScheduleId) {
  return request({
    url: '/homeSchool/scheduleAssessment/h5EvaluationDetail/' + studentScheduleId,
    method: 'get'
  })
}

// 根据排课计划ID查询学员点评状态列表
export function getReviewStudentList(schedulePlanId) {
  return request({
    url: '/homeSchool/scheduleAssessment/reviewStudentList/' + schedulePlanId,
    method: 'get'
  })
}

// 获取学员评价详情（编辑用）
export function getEvaluation(studentScheduleId) {
  return request({
    url: '/homeSchool/scheduleAssessment/getEvaluation/' + studentScheduleId,
    method: 'get'
  })
}

// 保存评价
export function saveEvaluation(data) {
  return request({
    url: '/homeSchool/scheduleAssessment/saveEvaluation',
    method: 'post',
    data: data
  })
}

// 获取启用的评价模板列表
export function listEnabledEvaluationTemplate() {
  return request({
    url: '/homeschool/evaluationTemplate/enabledList',
    method: 'get'
  })
}

// 确认考勤
export function confirmAttendance(schedulePlanId) {
  return request({
    url: 'educational/schedulePlan/confirmAttendance/' + schedulePlanId,
    method: 'get'
  })
}

// 查询可修改的排课课程
export function getScheduleCourseList(param) {
  return request({
    url: 'educational/course/getScheduleCourseList',
    method: 'get',
    params: param
  })
}

// 查询排课课程
export function getScheduleCourseListByStudent(param) {
  return request({
    url: 'educational/course/getScheduleCourseListByStudent',
    method: 'get',
    params: param
  })
}

// 修改排课数据
export function updateSchedulePlan(param) {
  return request({
    url: 'educational/schedule/updateClassTime',
    method: 'post',
    data: param
  })
}

// 修改考勤时间
export function updateAttendanceClassTime(param) {
  return request({
    url: 'educational/studentSchedule/updateAttendanceClassTime',
    method: 'post',
    data: param
  })
}

// 删除排课数据
export function removeSchedulePlan(param) {
  return request({
    url: 'educational/schedulePlan/removeSchedulePlan/1/' + param.schedulePlanId + '/' + param.scheduleId,
    method: 'delete',
  })
}

// 修改已考勤排课数据
export function updateAttendanceSchedulePlan(param) {
  return request({
    url: 'educational/schedulePlan/updateAttendanceSchedulePlan/' + param.schedulePlanId + '/' + param.overClassHour + "/" + param.isTransCampus,
    method: 'put'
  })
}

// 考勤
export function addAttendance(param) {
  return request({
    url: 'educational/studentSchedule/addAttendance',
    method: 'post',
    data: param
  })
}

// 获取排课学生列表
export function getStudentListByCourse(param) {
  return request({
    url: 'educational/student/getStudentListByCourse',
    method: 'get',
    params: param
  })
}

// 获取排课学生列表
export function getStudentListByCourseH5(param) {
  return request({
    url: 'educational/student/getStudentListByCourseForH5',
    method: 'get',
    params: param
  })
}

// 添加学生
export function addStudent(param) {
  return request({
    url: 'educational/studentSchedule',
    method: 'post',
    data: param
  })
}

// 添加学生
export function addSchedule(param) {
  return request({
    url: 'educational/schedule/addForH5',
    method: 'post',
    data: param
  })
}

// 排课
export function addScheduleForStudent(param) {
  return request({
    url: 'educational/schedule',
    method: 'post',
    data: param
  })
}

// 查询校区启用教室
export function getClassroomList(param) {
  return request({
    url: 'basedata/classroom/list',
    method: 'get',
    params: param
  })
}

// 查询学生
export function searchStudents(param) {
  return request({
    url: 'educational/student/listAll',
    method: 'post',
    params: param
  })
}

// 获取教师课时汇总数据
export function getTeacherClassHourStatics(param) {
  return request({
    url: 'educational/schedule/getTeacherClassHourStatics',
    method: 'get',
    params: param
  })
}

// 获取教师课时构成（一对一/小组课/班课，按校区/公司维度）
export function getTeacherClassHourComposition(param) {
  return request({
    url: 'educational/schedule/getTeacherClassHourComposition',
    method: 'get',
    params: param
  })
}

// 获取教师课次汇总数据
export function getTeacherPlanStatics() {
  return request({
    url: 'educational/schedulePlan/getTeacherPlanStatics',
    method: 'get'
  })
}

// 更新排课教案附件
export function updateSchedulePlanAnnex(data) {
  return request({
    url: 'educational/schedulePlan/updateAnnex',
    method: 'post',
    data
  })
}

// 班课订单录入：按当前公司查询可下单班级
export function getScheduleListForOrder(params) {
  return request({
    url: '/educational/schedule/getScheduleListForOrder',
    method: 'get',
    params
  })
}
